import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_slice_ml_asset, use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_diffusion_models from '@/locales/keys/i18n_page_diffusion_models.json';
import { SidebarWrapper } from '@/pages/_base/SidebarWrapper';
import { TopbarInfoWrapper } from '@/pages/_base/TopbarInfoWrapper';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DiffusionModelsTableUD } from '../tab_ud/diffusion_models_table_ud';
import { DiffusionModelsCheckboxShowOnlyUsedUD } from '../tab_ud/filters/diffusion_models_filter_checkbox_show_only_used_ud';
import { DiffusionModelsFilterDropdownFloatPrecisionUD } from '../tab_ud/filters/diffusion_models_filter_dropdown_float_precision_ud';
import { DiffusionModelsFilterInputSearchUD } from '../tab_ud/filters/diffusion_models_filter_input_search_ud';
import { DiffusionModelsFilterListBaseModelUD } from '../tab_ud/filters/diffusion_models_filter_list_base_model_ud';
import { DiffusionModelsFilterListModelTypeUD } from '../tab_ud/filters/diffusion_models_filter_list_model_type_ud';

interface Props {}

export function DiffusionModelsTabUD({}: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_DIFFUSION_MODELS);

  const { current_table } = use_slice_ml_asset(['current_table']);

  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  const search_amount = useMemo(() => get_search_amount(), [current_table]);

  let topbar_height = `calc(100% - ${CONSTANTS__client.TOPBAR_HEIGHT}px)`;

  /*
   * METHODS
   */

  function get_search_amount() {
    if (current_table.is_stub()) return 0;

    return current_table.items_amount_by_type_all;
  }

  /*
   * HTML
   */

  return (
    <div
      className={`h-full bg-component text-page-foreground flex text-left`}
      style={{ width: `${global_is_mobile ? '100%' : `calc(100vw - ${CONSTANTS__client.DESKTOP_NAV_BAR_WIDTH}px)`}` }}
    >
      <SidebarWrapper>
        <TopbarInfoWrapper />
        <div className={` flex  flex-col  pt-2  bg-bar`} style={{ height: topbar_height, maxHeight: topbar_height }}>
          <DiffusionModelsCheckboxShowOnlyUsedUD />
          <DiffusionModelsFilterDropdownFloatPrecisionUD />
          <DiffusionModelsFilterListModelTypeUD />
          <div className="flex-grow overflow-y-auto">
            <DiffusionModelsFilterListBaseModelUD />
          </div>
        </div>
      </SidebarWrapper>
      <div style={{ width: `calc(100% - ${CONSTANTS__client.SIDEBAR_LEFT_WIDTH}px` }} className={`h-full flex flex-col`}>
        <TopbarInfoWrapper>
          <span className="flex items-center justify-start px-4">
            {t(i18n_page_diffusion_models.topbar_table_title)}: {search_amount}
          </span>
        </TopbarInfoWrapper>
        <div className="w-full  gap-2 flex flex-col" style={{ height: topbar_height }}>
          <div className="w-full h-[56px] flex items-center border-b bg-bar px-5 ">
            <DiffusionModelsFilterInputSearchUD />
          </div>

          <div className="w-full h-full flex flex-col gap-3 px-5">
            <DiffusionModelsTableUD />
          </div>
        </div>
      </div>
    </div>
  );
}
